import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ClinicService } from 'src/app/_services/clinic.service';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { NurseAssignmentDialogComponent } from '../nurse-assignment-dialog/nurse-assignment-dialog.component';

@Component({
  selector: 'app-nurse-dashboard',
  templateUrl: './nurse-dashboard.component.html',
  styleUrls: ['./nurse-dashboard.component.scss'],
})
export class NurseDashboardComponent implements OnInit {
  clinics: any[] = [];
  selectedRow: any;
  loadingClinics: boolean = true;
  filteringForClinic: any;

  metaData: any = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  menuItems: MenuItem[] = [
    {
      label: 'Assign Nurse',
      icon: 'pi pi-pencil',
      command: () => {
        this.openNurseAssignmentDialog(this.selectedRow);
      },
    },
  ];

  constructor(
    private clinicService: ClinicService,
    private dialogService: DialogService,
    private messageService: MessageService
  ) {}

  // Define the columns for the clinic table
  clinicColumns: any[] = [
    { field: 'name', header: 'Clinic Name' },
    { field: 'professional_nurse', header: 'Professional Nurse' },
    { field: 'contact_number', header: 'Contact Number' },
    { field: 'province', header: 'Province' },
    { field: 'district', header: 'District' },
    { field: 'city', header: 'City' },
    { field: 'postal_code', header: 'Postal Code' },
    { field: 'email', header: 'Email' },
    { field: 'sanc_number', header: 'SANC Number' },
    { field: 'practice_number', header: 'Practice Number' },
    { field: 'sanc_qualification', header: 'SANC Qualification' },
  ];

  ngOnInit(): void {}

  storeRowDetail(details: any) {
    this.selectedRow = details;
  }

  items: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Assign Nurse',
          icon: 'pi pi-pencil',
          command: () => {
            this.openNurseAssignmentDialog(this.selectedRow);
          },
        },
      ],
    },
  ];

  openNurseAssignmentDialog(clinic: any) {
    const ref = this.dialogService.open(NurseAssignmentDialogComponent, {
      header: 'Assign Nurse',
      width: '50%',
      data: { clinic },
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Nurse assigned successfully',
        });
        this.clinicService.getAssignedClinics().subscribe((response: any) => {
          this.clinics = response.body.data;
          this.clinicService.updateClinics(response.body);
        });
      }
    });
  }

  getFilterInputValueForNurse(e: Event): any {
    const inputelement = e.target as HTMLInputElement;
    this.filteringForClinic = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringForClinic = '';
    }
    return inputelement.value;
  }

  loadClinicsLazy(event: any) {
    console.log('Loading clinics with event:', event.globalFilter);

    this.metaData = {
      limit: event?.rows || 100,
      offset: event?.first || 0,
      globalFilter: event?.globalFilter || '',
      sortField: event.sortField || '',
      sortOrder: event.sortOrder ?? null,
    };

    this.metaData.loading = true;

    this.clinicService.getAssignedClinics(this.metaData).subscribe(
      (response: any) => {

        
        this.clinics = response.body.data;
        this.metaData.totalRecords = response.body.count;

        this.clinics = this.clinics.map((clinic: any) => ({
          ...clinic,
          email: clinic.users[0]?.email || 'N/A',
          sanc_number: clinic.users[0].nurse_details?.sanc_number || 'N/A',
          practice_number: clinic.users[0]?.nurse_details?.practice_number || 'N/A',
          sanc_qualification: clinic.users[0]?.nurse_details?.sanc_qualification || 'N/A',
          contact_number: clinic.users[0]?.nurse_details?.contact_number || 'N/A',
        }));
        


        this.metaData.loading = false;
      },
      (error) => {
        this.metaData.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load clinics',
        });
      }
    );
  }
}
